/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Auto_Save_TitleInputs */

const en_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Save Settings`)
};

const fr_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres d'enregistrement automatique`)
};

const de_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen automatisch speichern`)
};

const it_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di salvataggio automatico`)
};

const ru_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки автоматического сохранения`)
};

const es_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de guardado automático`)
};

const zh_cn2_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动保存设置`)
};

const ja_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動保存設定`)
};

const hi_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स स्वचालित रूप से सहेजें`)
};

const pt_pt2_options_backup_auto_save_title = /** @type {(inputs: Options_Backup_Auto_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvamento automático de configurações`)
};

/**
* | output |
* | --- |
* | "Automatic Save Settings" |
*
* @param {Options_Backup_Auto_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_auto_save_title = /** @type {((inputs?: Options_Backup_Auto_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Auto_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_auto_save_title(inputs)
	if (locale === "de") return de_options_backup_auto_save_title(inputs)
	if (locale === "it") return it_options_backup_auto_save_title(inputs)
	if (locale === "ru") return ru_options_backup_auto_save_title(inputs)
	if (locale === "es") return es_options_backup_auto_save_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_auto_save_title(inputs)
	if (locale === "ja") return ja_options_backup_auto_save_title(inputs)
	if (locale === "hi") return hi_options_backup_auto_save_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_auto_save_title(inputs)
	return en_options_backup_auto_save_title(inputs)
});